import { Download } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const DownloadIcon = createLucideIcon(Download);
